import React from 'react';
import ReactDOM from 'react-dom';
import { useDispatch } from 'react-redux';
import moment from 'moment';
import StatusIndicatorForPIWA from './statusIndicatorForPIWA';
import { updateOpenOrClosedForWA } from '../../../actions/waitingArea';

export default function OpenOrClosedIndicator(props) {
  const dispatch = useDispatch();

  const getCurrentUTC = () => {
    return moment.utc();
  };

  const getWAStatus = () => {
    let currentTime = getCurrentUTC();

    let nextOpenTime = moment(props.waStatusObject.nextOpenTime, moment.ISO_8601);
    let nextCloseTime = moment(props.waStatusObject.nextClosedTime, moment.ISO_8601);
    let tmpNextCloseTime = nextCloseTime.clone();
    let isOpen = props.waStatusObject.isOpen;
    let isClosingSoon = false;
    let secondsLeftForClosing = null;
    let isOpenAllDay = nextOpenTime.isSame(tmpNextCloseTime.add(1, 'seconds')) ? true : false;

    if (nextOpenTime.isSameOrBefore(nextCloseTime)) {
      // The WA is considered to be closed when the server calculates the time
      if (nextOpenTime.isSameOrBefore(currentTime)) {
        // The WA is currently open then need to update the status
        isOpen = true;
        if (isOpen != props.waStatusObject.isOpen) {
          dispatch(updateOpenOrClosedForWA(props.waitingAreaId, isOpen));
        }
      }
    }
    if (nextOpenTime.isSameOrAfter(nextCloseTime)) {
      // The WA is considered to be open when the server calculates the time
      if (currentTime.isSameOrAfter(nextCloseTime)) {
        // The WA is currently closed then need to update the status
        isOpen = false;
        if (isOpen != props.waStatusObject.isOpen) {
          dispatch(updateOpenOrClosedForWA(props.waitingAreaId, isOpen));
        }
      }
    }

    if (isOpen) {
      // Check if it's closing soon
      secondsLeftForClosing = nextCloseTime.diff(currentTime, 'seconds');
      if (
        secondsLeftForClosing <= (props.waitingAreaClosingMessageThresholdMinutes || 15) * 60 &&
        secondsLeftForClosing > 0
      ) {
        isClosingSoon = true;
      }
    }

    return {
      isOpen: isOpen,
      isClosingSoon: isClosingSoon,
      isOpenAllDay: isOpenAllDay,
      secondsRemainForClosing: secondsLeftForClosing,
      nextOpenTime: nextOpenTime,
      nextCloseTime: nextCloseTime,
    };
  };

  let status = getWAStatus();
  if (status.isOpenAllDay === true) {
    return '';
  } else {
    return (
      <StatusIndicatorForPIWA
        status={status}
        waitingAreaId={props.waitingAreaId}
        timezone={props.timezone}
        timezoneSetUpforThisWA={props.waStatusObject.serviceTimeZone}
        messageThresholdMinutes={props.waitingAreaClosingMessageThresholdMinutes || 15}
      />
    );
  }
}
